import { createReducer } from '@reduxjs/toolkit';
import { TYPES } from '../../common/constants';

const savePaginationCount = (_, { payload }) => {
  return {
    count: payload
  }
};

const clearPaginationCount = () => {
  return initialState
}

const initialState = {
  count: 0
};

export default createReducer(initialState, {
  [TYPES.SERVICE_REQUEST_PAGINATION]: savePaginationCount,
  [TYPES.CLEAR_PAGINATION_COUNT]: clearPaginationCount,
});
